import type { HistoryDeliveryStatus, HistoryLotItem, HistoryOutcome } from '@skinstep/shared';
import type { Lot } from '../data/mockLots';
import { lotFromApi } from './lots';

// A finished lot plus the viewer's relationship to it. Reuses the live-lot view
// type for everything skin-visual (lotFromApi handles parsing/palette/StatTrak),
// then layers the per-user history fields on top.
export type HistoryLot = Lot & {
  outcome: HistoryOutcome;
  userBidCount: number;
  buyNowAvailable: boolean;
  buyNowPriceCents: number | null;
  deliveryStatus: HistoryDeliveryStatus | null;
  deliveryHoldUntil: number | null;
};

export function historyLotFromApi(item: HistoryLotItem): HistoryLot {
  // History items carry no live_state (the lot is finished); feed lotFromApi a
  // null one. Intersection keeps it a typed variable, so the extra history fields
  // don't trip the excess-property check when passed as a LotListItem.
  const asListItem: HistoryLotItem & { live_state: null } = { ...item, live_state: null };
  return {
    ...lotFromApi(asListItem),
    outcome: item.outcome,
    userBidCount: item.user_bid_count,
    buyNowAvailable: item.buy_now_available,
    buyNowPriceCents: item.buy_now_price_cents,
    deliveryStatus: item.delivery_status,
    deliveryHoldUntil: item.delivery_hold_until,
  };
}
